// extracted by mini-css-extract-plugin
export default {"notable-icon":"ImportantEventIcon-module__notable-icon__IYvXv","notableIcon":"ImportantEventIcon-module__notable-icon__IYvXv"};